import useToggle from './use-toggle';

export default () => useToggle()[1];
